export default __webpack_public_path__ + "static/media/bed-sheets.d6a6d5a2.svg";